export default {
  getDistanceFromLatLngInKm(lat1, lng1, lat2, lng2) {
    var R = 6371.0710; // Radius of the earth in km
    var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    var dLng = this.deg2rad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  },

  deg2rad(deg) {
    return deg * (Math.PI / 180);
  },

  convertDMSToDD(degrees, minutes, seconds, direction) {
    let dd = +degrees + +minutes / 60 + +seconds / (60 * 60);
    if (direction === 'S' || direction === 'W') {
      dd = dd * -1;
    }
    return dd;
  },

  parseDMS(input) {
    const parts = input.split(/[^\d\w]+/);
    const lat = this.convertDMSToDD(parts[0], parts[1], parts[2], parts[3]);
    const lng = this.convertDMSToDD(parts[4], parts[5], parts[6], parts[7]);
    return [lat, lng];
  },

  getDistance(from, to) {
    let distance = this.getDistanceFromLatLngInKm(
      from.lat,
      from.lng,
      to.lat,
      to.lng,
    );
    return distance;
  },
};
